import React from 'react';
import { Dots } from 'react-activity';
import 'react-activity/dist/react-activity.css';

import { Context as PortalContext } from '../context/portal.context.js';
import { Context as AuthContext } from '../context/auth.context.js';

const Loading = () => {
	const { state } = React.useContext(PortalContext);
	const authState = React.useContext(AuthContext);

	return (
		<div
			style={{
				display: authState.state.loading ? 'flex' : 'none',
				position: 'absolute',
				top: 0,
				left: 0,
				width: '100vw',
				height: '100vh',
				background: 'white',
				zIndex: 1000000000000,

				justifyContent: 'center',
				alignItems: 'center',
				flexDirection: 'column',
			}}
		>
			<div
				style={{
					display: 'flex',
					padding: 50,
					borderRadius: 10,
					backgroundColor: 'white',
					justifyContent: 'center',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				<img
					src={state.merchantLogoURL}
					height={100}
					style={{ marginBottom: 20 }}
				/>
				<Dots />
			</div>
		</div>
	);
};

export default Loading;
